import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4fvfm8f5: FaireBrandEntity = {
  token: "b_4fvfm8f5",
  type: "brand",
  name: "DONA",
  avatarUrl:
    "https://cdn.faire.com/fastly/3953acedc0cb0ce8e59972b2b20147853b73f65dc2d8cb56f6326b801714b653.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4e66b09558cbf76ffedc4eecace1ee664b95eb67c5373d1dff6e752f8107dd89.png",
  logoUrl:
    "https://cdn.faire.com/fastly/3953acedc0cb0ce8e59972b2b20147853b73f65dc2d8cb56f6326b801714b653.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4e66b09558cbf76ffedc4eecace1ee664b95eb67c5373d1dff6e752f8107dd89.png",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 124,
  isTopShop: true,
  isInsider: true,
  description:
    "Dona is an independently owned tea company in Brooklyn, NY dedicated to high quality ingredients and in-house production. We prioritize direct trade, small scale farmers, and all the good stuff that makes the quality super high and leaves a positive impact on the food system.",
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:15:49.950Z",
    importedBy: "entity-db-cli",
  },
};
